const Configurations = {
	currentDay: [
		{ name: 'Installationsort', value: row => row.device.name },
		{
			name: 'Temperatur Soll',
			value: row => row.device.target,
		},
	],
	currentWeek: [{ name: 'Tag', value: row => row.day }],
}

const IoConfigurations = {
	currentDay: [
		{ name: 'Installationsort', value: row => row.device.name },
		{
			name: 'Status Stromversorgung',
			value: row =>
				isIoModulePowered(row.device.last_timestamp)
					? 'Dieses Gerät ist stromversorgt'
					: 'Dieses Gerät scheint offline zu sein',
		},
	],
	currentWeek: [{ name: 'Tag', value: row => row.day }],
}

const POWERED_THRESHOLD_MINUTES = 60

const isIoModulePowered = lastTimestamp => {
	const lastSeen = new Date(lastTimestamp)
	const minutesSinceLastSeen =
		(new Date().getTime() - lastSeen.getTime()) / 1000 / 60

	return (
		lastTimestamp &&
		!isNaN(lastSeen.getTime()) &&
		minutesSinceLastSeen >= 0 &&
		minutesSinceLastSeen < POWERED_THRESHOLD_MINUTES
	)
}

const mapIoStatus = status => {
	switch (status) {
		case 'alarm':
			return 'Alarm'
		case 'functional':
			return 'Kein Alarm'
		case 'offline':
			return 'Offline'
		default:
			return null
	}
}

const createCSV = async (array, name) => {
	const columnDelimiter = ','
	const lineDelimiter = '\n'

	const csvContent = array
		.map(row => row.join(columnDelimiter))
		.join(lineDelimiter)

	const blob = new Blob(['\ufeff' + csvContent], {
		type: 'text/csv;charset=utf-8;',
	})
	const url = window.URL.createObjectURL(blob)

	const link = document.createElement('a')
	link.setAttribute('href', url)
	link.setAttribute('download', name + '.csv')
	link.style.display = 'none'

	document.body.appendChild(link)
	link.click()

	document.body.removeChild(link)
	window.URL.revokeObjectURL(url)

	return true
}

// TODO: Future: if needed make this more generic (not only for temperature)
const downloadCSV = async (array, current, name, csvValue) => {
	if (!current) return false

	const rows = array.filter(row =>
		csvValue === 'ioStatus' ? row.device.isIoModule : !row.device.isIoModule
	)
	const configurations =
		csvValue === 'ioStatus' ? IoConfigurations[current] : Configurations[current]

	const myArray = [
		configurations
			.map(item => item.name)
			.concat(Array.from({ length: 24 }, (_, i) => i.toString())),
	]

	rows.forEach(row => {
		const rowData = configurations
			.map(item => item.value(row))
			.concat(
				Array.from({ length: 24 }, (_, i) =>
					csvValue === 'ioStatus'
						? mapIoStatus(row.values['hour_' + i][csvValue])
						: row.values['hour_' + i][csvValue] || null
				)
			)
		myArray.push(rowData)
	})

	const myCSV = await createCSV(myArray, name)

	return myCSV
}
export default downloadCSV
